import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Firebase configuration using environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyB7vCUyR5OfOVZsEPEHyTo-kUQs_eJ6njQ",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "baballouk0.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "baballouk0",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "baballouk0.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "54077608350",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:54077608350:web:098b0fbd36234e44a1868f"
};

console.log("Firebase configuration being used:", {
  apiKey: firebaseConfig.apiKey ? "VALID_KEY_PROVIDED" : "NO_KEY_PROVIDED",
  authDomain: firebaseConfig.authDomain,
  projectId: firebaseConfig.projectId
});

// Ensure we have only one Firebase instance
let app: FirebaseApp;

try {
  if (getApps().length === 0) {
    // Initialize Firebase if no app exists
    console.log('Initializing new Firebase app');
    app = initializeApp(firebaseConfig);
  } else {
    // Re-use existing Firebase app
    console.log('Re-using existing Firebase app');
    app = getApp();
  }
} catch (error) {
  console.error('Error initializing Firebase app:', error);
  throw new Error('فشل في تهيئة تطبيق Firebase');
}

// Initialize Firestore
const db = getFirestore(app);

// Initialize Authentication
const auth = getAuth(app);

// Configure Auth persistence
(async () => {
  try {
    await setPersistence(auth, browserLocalPersistence);
    console.log('Authentication persistence set to LOCAL');
  } catch (error) {
    console.error('Error setting authentication persistence:', error);
  }
})();

// Enable Firestore offline persistence
(async () => {
  try {
    await enableIndexedDbPersistence(db);
    console.log('Firestore offline persistence has been enabled');
  } catch (err: any) {
    if (err.code === 'failed-precondition') {
      console.warn('Firestore persistence failed - multiple tabs open');
    } else if (err.code === 'unimplemented') {
      console.warn('Firestore persistence is not available in this browser');
    } else {
      console.error('Firestore persistence error:', err);
    }
  }
})();

// Export the Firestore database instance and auth
export { db, auth }; 